import { Typography } from "@/components/ui/typography";
import SvgError from "@/assets/icons/Error";
import Image from "next/image";

type StatusContainerProps = {
  title: React.ReactNode;
  iconSrc?: string;
  icon?: React.ReactNode;
  heading: React.ReactNode;
  desc: React.ReactNode;
  button?: React.ReactNode;
};

export default function StatusContainer({
  title,
  heading,
  desc,
  button,
  iconSrc,
  icon,
  children,
}: React.PropsWithChildren<StatusContainerProps>) {
  return (
    <>
      <title>{title}</title>
      <div className="flex flex-grow flex-col gap-14 md:flex-initial md:gap-12">
        <div className="flex flex-col gap-4 md:gap-6">
          <Typography component="p" variant="eyebrow" className="text-center">
            {title}
          </Typography>
          <div className="flex flex-col items-center p-3">
            <div className="relative flex h-12 w-12 items-center justify-center md:h-14 md:w-14">
              {icon
                ? icon
                : (iconSrc && (
                    <Image src={iconSrc} alt={`${title}`} fill />
                  )) || <SvgError />}
            </div>
          </div>
          <Typography component="h1" variant="h1-xl">
            {heading}
          </Typography>
        </div>
        {children}
        <Typography component="p" className="text-center">
          {desc}
        </Typography>

        <div className="m-0 flex w-full flex-auto flex-col items-center justify-end md:flex-initial">
          <div className="w-full max-w-[26rem]">{button}</div>
        </div>
      </div>
    </>
  );
}
